import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Modal } from "react-bootstrap";
import styled from "styled-components";
import { ModalHeaderBlack, MyModal } from "../../features/RadConnStyle";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { BsCrop } from "react-icons/bs";
import { TbCapture } from "react-icons/tb";
import { MdOutlineSplitscreen } from "react-icons/md";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import { useDispatch } from "react-redux";
import { setReminder } from "../../features/UserActions";

function ScreenCapture(props) {
  const dispatch = useDispatch();
  const { userDetail, selectedRow, setCaptureResult, setShowScreenCapture } =
    props;
  const videoRef = useRef(null);
  const imageRef = useRef(null);
  const blockerRef = useRef(null);
  const btnSaveRef = useRef(null);

  const refStartPoint = useRef([0, 0]);
  const refEndPoint = useRef([0, 0]);
  const refDraging = useRef(false);
  const refReady = useRef(false);

  const [newMode, setNewMode] = useState(false);
  // const [cropMode, setCropMode] = useState(false);

  useEffect(() => {}, [selectedRow]);

  // handle mouse event for Crop picture ....
  const initXY = (e) => {
    if (e) {
      // keep value to ref
      refStartPoint.current = [e.nativeEvent.offsetX, e.nativeEvent.offsetY];
    }
  };

  const handleMouseDown = useCallback((e) => {
    refDraging.current = true;
    initXY(e);
  }, []);

  const handleMouseUp = useCallback((e) => {
    // setCropMode(false);
    let x2 = e.nativeEvent.offsetX;
    let y2 = e.nativeEvent.offsetY;
    refEndPoint.current = [x2, y2];
    refDraging.current = false;
    drawFrame(e);
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (!refDraging.current) return;

    let canvas = blockerRef.current;
    let ctx = blockerRef.current.getContext("2d");
    let scaleX = canvas.width / e.target.clientWidth;
    let scaleY = canvas.height / e.target.clientHeight;
    let xy1 = refStartPoint.current;
    let x2 = e.nativeEvent.offsetX;
    let y2 = e.nativeEvent.offsetY;
    ctx.clearRect(0, 0, ctx.canvas.offsetWidth, ctx.canvas.offsetHeight);
    ctx.fillRect(
      Math.floor(xy1[0] * scaleX),
      Math.floor(xy1[1] * scaleY),
      (x2 - xy1[0]) * scaleX,
      (y2 - xy1[1]) * scaleY
    );
  }, []);

  // show video and capture
  const startPlay = (displayMediaOptions) => {
    setNewMode(true);
    navigator.mediaDevices
      .getDisplayMedia({
        video: { cursor: "always" },
        audio: false,
      })
      .then((stream) => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
        setTimeout(captureImage, 500);
      })
      .catch((error) => {
        console.error(error.error);
      });
  };

  // captures image from video box area
  const captureImage = async () => {
    let photo = imageRef.current;
    let video = videoRef.current;
    photo.width = video.offsetWidth;
    photo.height = video.offsetHeight;
    let ctx = photo.getContext("2d");
    ctx.drawImage(video, 0, 0, photo.width, photo.height);
    let tracks = video.srcObject.getTracks();
    if (tracks != null) {
      tracks.forEach((track) => {
        track.stop();
      });
    }
    video.srcObject = null;
    //  navigator.mediaDevices.getUserMedia({
    //       video:false
    //   });

    photo.style.width = `${photo.width}px`;
    photo.style.height = `${photo.height}px`;

    blockerRef.current.style.display = "block";
    setTimeout(cropImage, 500);
    setNewMode(false);
  };

  const cropImage = () => {
    let cropLayer = blockerRef.current;
    let photo = imageRef.current;
    cropLayer.style.left = `${photo.offsetLeft}px`;
    cropLayer.style.top = `${photo.offsetTop}px`;
    cropLayer.style.width = `${photo.offsetWidth}px`;
    cropLayer.style.height = `${photo.offsetHeight}px`;
  };

  const drawFrame = (e) => {
    let imgBox = imageRef.current;
    let ctxFrame = blockerRef.current.getContext("2d");
    let ctxImage = imgBox.getContext("2d");

    ctxFrame.clearRect(
      0,
      0,
      ctxFrame.canvas.offsetWidth,
      ctxFrame.canvas.offsetHeight
    );
    ctxFrame.fillStyle = "green";

    // show cropped data
    let xy1 = refStartPoint.current;
    let xy2 = refEndPoint.current;
    let imgWidth = xy2[0] - xy1[0];
    let imgHeight = xy2[1] - xy1[1];

    const imageData = ctxImage.getImageData(
      xy1[0],
      xy1[1],
      imgWidth,
      imgHeight
    );
    imgBox.width = imgWidth;
    imgBox.height = imgHeight;
    ctxImage.putImageData(imageData, 0, 0);

    // set new image size
    imgBox.style.width = `${imgWidth}px`;
    imgBox.style.height = `${imgHeight}px`;

    refReady.current = true;
    setTimeout(cropImage, 300);
    setNewMode(false);
  };

  const UpLoadFile = () => {
    let photo = imageRef.current;
    let ctx = photo.getContext("2d");
    let image = photo.toDataURL("image/png");
    image = image.replace("data:image/png;base64,", "");

    const formData = new FormData();
    formData.append("user", JSON.stringify({ ...userDetail, uploadType: 2 })); // uploadType(1=file, 2=captured image, 3=scanned image)
    formData.append("rowdata", JSON.stringify(selectedRow));
    formData.append("image", JSON.stringify({ image: image }));

    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/study-update-web-capture",
        formData,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data) {
          ctx.clearRect(0, 0, photo.width, photo.height);
          refReady.current = false;
          setNewMode(false);
          setCaptureResult(true);
          setShowScreenCapture(false);
          image = null;
          dispatch(
            setReminder({
              show: true,
              message: "มีการ Upload ไฟล์ไปที่ Server แล้ว",
            })
          );
        } else {
          dispatch(setReminder({ show: true, message: "การ Uplaod ผิดพลาด" }));
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <MyModal
      show={props.showScreenCapture}
      size="xl"
      onHide={() => props.setShowScreenCapture(false)}
      backdrop={false}
      centered
      //dialogClassName="modal-98w modal-98v"
      aria-labelledby="example-custom-modal-styling-title"
      fullscreen={true}
    >
      <ModalHeaderBlack closeButton style={{ maxHeight: "40px" }}>
        <TbCapture
          style={{ color: "yellow", fontSize: "30px", margin: "0 5px 0 5px" }}
        />
        Capture หน้าจอ เพื่อส่งเข้าระบบ {props.formName}
      </ModalHeaderBlack>
      <Modal.Body>
        <HBox style={{ padding: "3px 3px 10px 3px" }}>
          <Button onClick={() => startPlay()} style={{ marginRight: "5px" }}>
            <MdOutlineSplitscreen
              style={{ marginRight: "5px", color: "yellow" }}
            />
            New{" "}
          </Button>

          {/* <Button onClick={()=>captureImage()}
                style = {{margin:'1px 5px 1px 1px'}} 
                >
                  <TbCapture style={{marginRight:'5px', color:'yellow'}} />
                  จับภาพหน้าจอ
                </Button>  */}

          <Button
            disabled={newMode}
            onClick={() => cropImage()}
            style={{ margin: "1px 5px 1px 1px" }}
          >
            <BsCrop style={{ marginRight: "5px", color: "yellow" }} />
            ตัดภาพ
          </Button>

          <Button
            disabled={newMode}
            ref={btnSaveRef}
            onClick={() => UpLoadFile()}
            style={{ margin: "1px 5px 1px 1px" }}
          >
            <AiOutlineCloudUpload
              style={{ marginRight: "5px", color: "yellow" }}
            />
            Upload
          </Button>

          <Button
            onClick={() => props.setShowScreenCapture(false)}
            variant="danger"
          >
            Close
          </Button>
        </HBox>

        <HBox>
          <VideoBox
            ref={videoRef}
            style={{ display: newMode ? "flex" : "none" }}
          ></VideoBox>
          <PictureBox
            ref={imageRef}
            style={{ display: newMode ? "none" : "" }}
          ></PictureBox>
          <FrameBlocker
            style={{ display: newMode ? "none" : "" }}
            ref={blockerRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
          />
        </HBox>
      </Modal.Body>
    </MyModal>
  );
}

export default React.memo(ScreenCapture);

const HBox = styled.div`
  /* display: flex;     */
  align-items: center;
  justify-items: center;
  justify-content: center;
`;

const VideoBox = styled.video`
  border: 5px solid #fa6f23;
  background-color: black;
  border-radius: 5px;
  flex: 1;
`;

const PictureBox = styled.canvas`
  flex: 1;
  border: 5px solid #fa6f23;
  border-radius: 5px;
  box-shadow: #444444 10px 12px 15px;
  background-color: black;
`;

const FrameBlocker = styled.canvas`
  position: absolute;
  display: "block";
  /* width: 100vw; */
  border: 5px solid #13ee07;
  border-radius: 5px;
  opacity: 0.8;
`;
